module.exports = __webpack_public_path__ + "img/comment_2.749a7ae4.png";